// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__3_VRr"};